import createAuth0Client from '@auth0/auth0-spa-js';
import {message} from "antd";
import {history} from "../configs/history";

const {
    REACT_APP_domain,
    REACT_APP_clientId,
    REACT_APP_audience,
    REACT_APP_scope,
} = process.env;

const logoutUser = async ({showLoginPage}) => {
    const redirect_uri = window.location.origin + '/app-loading';
    const auth0FromHook = await createAuth0Client({
        domain: REACT_APP_domain,
        client_id: REACT_APP_clientId,
        redirect_uri,
        audience: REACT_APP_audience,
        scope: REACT_APP_scope
    });
    const returnLink = window.location.origin;
    const logoutObj = {returnTo: returnLink};
    localStorage.clear();
    message.warning('your session has been expired, please login again');
    if (!!showLoginPage) {
        await auth0FromHook.loginWithRedirect({redirect_uri})
    }
    auth0FromHook.logout(logoutObj);
}

export const errorHandler = async (status) => {
    switch (status) {
        case 500:
            history.push('/service-unavailable');
            break;
        case 404:
            history.push('/notfound');
            break;
        case 401:
            await logoutUser({showLoginPage: true});
            break;
        default:
            await logoutUser({showLoginPage: true});
    }
}